import { ReceptionBookingDetails } from '@models/reception'
import Decimal from 'decimal.js'
import { asDecimal } from '@helpers/utils'

export const calculateRestToPayCheckin = (booking: ReceptionBookingDetails): Decimal =>
  Decimal.max(asDecimal(booking.required_payment_without_climatic_tax), 0).plus(
    Decimal.max(asDecimal(booking.required_climatic_tax), 0),
  )
